/**
 * Plausible Analytics utility
 * All custom event props are cast to strings (Plausible requirement).
 *
 * Uses window.plausible() (the JS client loaded in index.html) as the
 * sole method. No sendBeacon fallback — sendBeacon to the raw API
 * causes duplicate events and hostname mismatches on custom domains.
 */

/** Global call counter for debugging duplicates */
let _callId = 0;

/** Normalize props: stringify values, lowercase coach. */
const buildProps = (props) => {
  const out = {};
  for (const [key, value] of Object.entries(props)) {
    if (value != null) {
      out[key] = key === 'coach' ? String(value).toLowerCase() : String(value);
    }
  }
  return out;
};

/**
 * Track a custom event via window.plausible() only.
 * One call = one event. No fallback, no duplication.
 */
export const trackEvent = (eventName, props = {}) => {
  const id = ++_callId;
  const stringProps = buildProps(props);

  console.warn(`[Analytics #${id}] trackEvent("${eventName}")`, stringProps);
  // console.trace(`[Analytics #${id}] call stack`);

  try {
    if (typeof window.plausible === 'function') {
      window.plausible(eventName, { props: stringProps });
      console.warn(`[Analytics #${id}] sent via window.plausible()`);
    } else {
      console.warn(`[Analytics #${id}] SKIPPED — window.plausible not available`);
    }
  } catch (e) {
    console.warn(`[Analytics #${id}] ERROR:`, e);
  }
};
